import { get } from "@/request/http";

// 获取底部信息
export const getFooter = id =>
  get("/getVirtualSimulationInfoV2", {
    id: id,
    param: "footer"
  });
